import { Button, DialogActions, DialogContent, DialogContentText } from '@mui/material'

import DialogWithTitle from '../../../../components/dialog-with-title'

const DialogLoadAll = ({ open, onClose, onContinue }: { open: boolean; onClose: () => void; onContinue: () => void }) => (
  <DialogWithTitle open={open} setOpen={onClose} title="Load all data">
    <DialogContent>
      <DialogContentText>
        Do you want to load all historical data for this chart? Loading all historical data may take a while and leaving this page will stop the process. You
        will still be able to interact with the chart while the data is loading in the background.
      </DialogContentText>
      <DialogActions sx={{ marginY: 2 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onContinue}>
          Confirm
        </Button>
      </DialogActions>
    </DialogContent>
  </DialogWithTitle>
)

export default DialogLoadAll
